import { ChangeEvent, useCallback, useState } from "react";

interface SettingFieldNumberProps {
  title: string;
  ariaLabel: string;
  inputName: string;

  required?: boolean;

  defaultValue?: number;
  onChange?: (value?: number) => void;
}

const SettingFieldNumber = (props: SettingFieldNumberProps) => {
  let [inputValue, setInputValue] = useState(props.defaultValue);
  let { onChange } = props;

  const onInputChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value ? parseInt(event.target.value) : undefined;
    setInputValue(value);

    if (onChange) {
      onChange(value);
    }
  }, [onChange]);
  
  return (
    <div className="stat-box">
      <span className="stat-box-title">{props.title}</span>
      <span className="stat-box-value">
        <input
          type="number"
          aria-label={props.ariaLabel}
          name={props.inputName}
          min={1}
          value={inputValue}
          required={props.required}
          onChange={onInputChange} />
      </span>
    </div>
  );
};

export default SettingFieldNumber;